import type { MealMonitoringDetailSummary } from "../../../../../api/meal/types/mealMonitoringDetailType";

interface MealDetailSummaryProps {
  summary: MealMonitoringDetailSummary | null;
}

const getMenuIcon = (name: string) => {
  const value = name.toLowerCase();

  if (value.includes("ayam")) return "🍗";
  if (value.includes("daging") || value.includes("sapi")) return "🥩";
  if (value.includes("ikan")) return "🐟";
  if (value.includes("sehat")) return "🥗";
  if (value.includes("spesial")) return "🍱";
  if (value.includes("telur")) return "🍳";

  return "🍽️";
};

const MealDetailSummary = ({ summary }: MealDetailSummaryProps) => {
  if (!summary) {
    return null;
  }

  const menus = summary.menu ?? [];

  return (
    <section className="rounded-xl border border-gray-100 bg-white p-2.5 shadow-sm">
      <p className="px-1 pb-2 text-xs font-semibold text-[#555]">
        Ringkasan Menu
      </p>

      <div
        onPointerDown={(event) => event.stopPropagation()}
        onTouchStart={(event) => event.stopPropagation()}
        className="flex gap-1.5 overflow-x-auto"
        style={{
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        {menus.map((menu) => (
          <div
            key={menu.menu_uuid}
            className="flex h-[72px] min-w-[72px] flex-1 flex-col items-center justify-center rounded-lg border border-gray-100 bg-white shadow-sm"
          >
            <div className="flex items-center gap-1">
              <span className="text-[11px]">{getMenuIcon(menu.category)}</span>

              <span className="max-w-[45px] truncate text-[10px] font-medium text-[#555]">
                {menu.category}
              </span>
            </div>

            <span className="mt-1 text-[16px] font-bold leading-none text-[#444]">
              {menu.total}
            </span>

            <span className="mt-1 text-[8px] text-gray-400">Meal</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MealDetailSummary;
